import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'lrnr-p',
	template: `
		<iframe
			src="https://scribehow.com/page/Partner_Essentials__00Wo3RmfRz6NkWn_nq3UpA"
			width="100%"
			allowfullscreen="true"
			style="border: 0; height: calc(100vh - 160px)"
		></iframe>
	`
})
export class PartnerEssentialsComponent {}
